<template>
    <!--
        作者：kmdshop
        时间：2020-06-01
        描述：插件中心-产品-修改
      -->
      <el-dialog
      title="设置产品权限"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
    >
  
    <div class="product-add pb50">
  
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
       
        <el-table :data="role" style="width: 100%">
            <el-table-column label="全选" width="180">
                <template #header>
                <el-checkbox 
                    v-model="selectAll" 
                    @change="handleSelectAllChange"
                >全部</el-checkbox>
                </template>
            </el-table-column>
            <el-table-column prop="label" label="角色名称" width="180"></el-table-column>
            <el-table-column label="选择" width="180">
                <template #default="scope">
    
                <el-checkbox-group v-model="form.selectedRoles">
                    <el-checkbox :label="scope.row.value">{{ '' }}</el-checkbox>
                </el-checkbox-group>
                </template>
            </el-table-column>
            </el-table>
   
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
      </Upload>
     </div>
  </el-dialog>
    
  </template>
  
  <script>
  import HproductApi from '@/api/hproduct.js';
  import Upload from '@/components/file/Upload';
  import Categoryas from "@/components/categorya/index.vue";
  import draggable from "vuedraggable";
  import Uediter from '@/components/UE.vue';
  import UserApi from '@/api/user.js';
  export default {
    components: {
       /*图片上传*/
       Upload: Upload,
       Categoryas,
       draggable,
       Uediter
    },
    data() {
      return {
            /*是否上传图片*/
            isupload: false,
        isImg: false,  
            /*富文本配置*/
            ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        },
        /*form表单数据*/
        form: {
            selectedRoles:[]
        },
        loading: false,
        /*验证规则*/
        rules: {
          name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        },
        dialogVisible:false,
        iscategorya:false,
        excludeIds:[],
        isProductUpload:false,
           code:"album",
           type:[],
           parameterList:[],
           catgory:[],
           role:[],
           selectAll: false,
      };
    },
    created() {
      console.log(11111)
      this.dialogVisible = this.open_add;
    
      this.getRole();
    },
    props: ["open_add","hproduct_id",'obj'],
    methods: {
        handleSelectAllChange(val) {
            if (val) {
            this.form.selectedRoles = this.role.map(item => item.value);
            } else {
            this.form.selectedRoles = [];
            }
        },
        getRole(){
        let self = this

        let Params = {}

        UserApi.getRole(Params, true)
            .then(data => {
                self.role = data.data
                if( self.obj.auth){
                    console.log('???')
                    self.form.selectedRoles = self.obj.auth;
                }
            })
            .catch(error => {

        });
    },
       // 选择一级参数
       parameterChange(e){
           let that = this 
           let par = e
           var ind = 0;
           that.form.hproducttoattrs.forEach((v,i) => {
                   if(v.category_id == e.category_id){
                       ind++;
                   }
               })
           if(ind <= 0){
            that.form.hproducttoattrs.push(e)
           }
       },
       
       // 删除参数
       delPara(index){
           let that = this 
           that.form.hproducttoattrs.splice(index,1)
           console.log(index)
       },
       
       // 获取参数列表
       getData() {
           let self = this;
           HproductApi.attrList({
                   supply_id: " "
               }, true)
               .then(data => {
                   console.log("data", data.data.list)
                   if(data.code == 1){
                       self.parameterList = data.data.list
                   }
                   // self.loading = false;
                   // self.tableData = data.data.list;
                   // self.categoryModel.catList = self.tableData;
               })
               .catch(error => {
                   self.loading = false;
               });
       },
      getSetting(){
        var self = this;
        self.getSetting_common({
          "item":'hproduct',
          "condi":['catgory','hproduct_subcategory']
        },function(data){
            self.type = data.obj.hproduct_subcategory
            self.catgory = data.obj.catgory;
        })
      },
      delType(index){
          this.form.hproducttosubcategories.splice(index,1)
      },
  

      chooseCategory(){
        this.iscategorya = true;
      },
       /*上传*/
       openUpload(e) {
        this.isupload = true;
      },
  
       /*获取图片*/
       returnImgsFunc(e) {
        let self = this;
        if (e != null) {
          this.form.image_id = e[0].file_id;
            this.form.image = e[0].file_path;
            this.isImg = true;
          
        }
        this.isupload = false;
      },
       /*关闭弹窗*/
       dialogFormVisible(result) {
        this.$emit("close", {});
      },
      cancelFunc(){//取消
        this.dialogFormVisible("error")
      },
      getDetail() {
        let self = this;
        // 取到路由带过来的参数
        HproductApi.detail({hproduct_id: self.hproduct_id},true).then(res => {
            self.form = res.data;
            self.ueditor.text = self.form.intro;
            self.isImg = true
            self.loading = false;
            if(!self.form.bannar){
              self.form.bannar = [];
            }
            if(!self.form.image){
              self.form.image = [];
            }
          })
          .catch(error => {});
      },
      onSubmit() {
        let self = this;
        let form = self.form;
        form.hproduct_id = self.hproduct_id;
  
        self.loading = true;
            HproductApi.editAuth(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.dialogFormVisible("error")
              })
              .catch(error => {
                self.loading = false;
              });
      },
  
      /*取消修改，返回任务列表*/
      cancelFunc() {
        this.$emit("close", { openDialog: false,"type":"" });
      },
      openProductUpload: function (code) {
        this.isProductUpload = true;
        this.code = code
      },
  
    

  
      /*删除商品图片*/
      deleteImg(index,code) {
        if(code == 'album'){
          this.form.image.splice(index, 1);
        }else if(code == 'bannar'){
          this.form.bannar.splice(index, 1);
        }
        
      },
    }
  };
  </script>
  
  <style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  
  .ql-editor {
    height: 400px;
  }
  
  
  
  .draggable-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  
  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  
  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }
  
  .draggable-list .item:hover .delete-btn {
    display: block;
  }
  
  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }
  
  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }
  
  .draggable-list .img-select i {
    color: #409eff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/plus/supply/product/part/auth.vue